var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAiChatBot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#5416BF",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07758 7.86947C9.58232 6.20864 11.1258 5 12.9516 5C15.1875 5 17 6.81253 17 9.04837C17 9.87721 16.7507 10.6477 16.3233 11.2894L16.6159 12.2654L15.488 12.2035C15.0878 12.5257 14.625 12.7733 14.1208 12.9253M13.551 14.5489C13.8725 13.9271 14.054 13.2212 14.054 12.473C14.054 9.97275 12.0272 7.94595 9.527 7.94595C7.02678 7.94595 5 9.97278 5 12.473C5 13.3998 5.27875 14.2614 5.75664 14.979L5.42948 16.0704L6.69073 16.0012C7.46686 16.6259 8.45318 17 9.52703 17C10.3543 17 11.1298 16.7781 11.7972 16.3905",
    stroke: "#5416BF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiChatBot);
export default __webpack_public_path__ + "static/media/icon-ai-chat-bot.5a73b4dc17ab59017fdb1c6795ec9346.svg";
export { ForwardRef as ReactComponent };